<mat-toolbar class="toolbar">
    @if (domainSettings) {
        <div class="domain-container">
            <button mat-icon-button class="domain-button" [matMenuTriggerFor]="menu">
                <mat-icon class="dashboard-icon">apps</mat-icon>
            </button>
            <mat-menu #menu="matMenu" class="avmup-menu">
                @for (app of cesarApplications; track app) {
                    <div>
                        <a class="avmup-menu-item" href="{{ getUrl(app.url) }}" mat-menu-item>
                            <img class="app-icon" src="{{ app.icon }}" />
                            <span>{{ app.display }}</span>
                        </a>
                    </div>
                }
            </mat-menu>
            <img class="domain-logo" src="{{ domainSettings.logo }}" />
        </div>
    }

    <span class="application-title">Global User Management{{ externalApplicationTitle ? ' - ' + externalApplicationTitle : '' }}</span>

    <span class="space"></span>

    @if (showOrganizationResearch && showTopbarConnectedUser()) {
        <div class="search-organization" [ngClass]="{ 'search-organization-hidden': !currentOrganization }">
            @if (searchControl && currentOrganization) {
                <form [formGroup]="searchControl">
                    <fa-icon class="filter-icon" [icon]="faFilter"></fa-icon>
                    <mat-label class="filter-label">{{ 'NavTopBar.Organizations' | translate }} :</mat-label>
                    <span [ngClass]="{ 'label-search-hidden': isEditable, 'label-search': true }" (click)="onEdit()">
                        <mat-form-field>
                            <input matInput class="filter-input" type="text" formControlName="organization" readonly />
                            <mat-icon matSuffix>close</mat-icon>
                        </mat-form-field>
                    </span>
                    <span [ngClass]="{ 'form-search-hidden': !isEditable, 'form-search': true }" appearance="fill">
                        <mat-form-field>
                            <input
                                matInput
                                type="text"
                                class="filter-auto-input"
                                appearance="fill"
                                #search
                                #trigger="matAutocompleteTrigger"
                                placeholder="Recherche..."
                                formControlName="organizationControl"
                                [matAutocomplete]="auto"
                                (focusout)="focusout()"
                                (focus)="focus()" />
                            @if (search.value.length < 1) {
                                <mat-icon matSuffix>search</mat-icon>
                            } @else {
                                <mat-icon matSuffix>close</mat-icon>
                            }
                            <mat-autocomplete
                                autoActiveFirstOption
                                #auto="matAutocomplete"
                                [displayWith]="displayWith"
                                hideSingleSelectionIndicator="true"
                                (optionSelected)="selectOrganization($event.option.value); search.blur()">
                                @for (organization of organizationsFilter; track organization) {
                                    <mat-option [value]="organization">
                                        {{ organization.display }}
                                    </mat-option>
                                }
                            </mat-autocomplete>
                        </mat-form-field>
                    </span>
                </form>
            }
        </div>
    }

    <span class="space"></span>

    <div [ngClass]="{ options: currentOrganization, 'options-disconnected': true }">
        @if (currentUser && showTopbarConnectedUser()) {
            <span class="display">
                {{ 'NavTopBar.Welcome' | translate: { displayName: currentUser.display ? currentUser.display : currentUser.account } }}
                <!-- <fa-icon [icon]="faUser"></fa-icon> -->
            </span>

            <mat-icon>person</mat-icon>

            <button mat-icon-button [matMenuTriggerFor]="menu">
                <!-- <fa-icon [icon]="faBars"></fa-icon> -->
                <mat-icon>menu</mat-icon>
            </button>
        }

        <mat-menu #menu="matMenu">
            <button mat-menu-item [matMenuTriggerFor]="languages">
                <mat-icon>language</mat-icon>
                <span>{{ 'NavTopBar.Langues' | translate }}</span>
            </button>

            <button mat-menu-item (click)="about()">
                <mat-icon>help_outline</mat-icon>
                <span>{{ 'NavTopBar.About' | translate }}</span>
            </button>

            <button mat-menu-item (click)="modifyPassword()">
                <mat-icon>vpn_key</mat-icon>
                <span>{{ 'NavTopBar.ChangePassword' | translate }}</span>
            </button>
        </mat-menu>

        <mat-menu #languages="matMenu">
            <button mat-menu-item (click)="frenchLanguage()">
                <img classe="resize" src="assets/images/france.webp" />
                <span>{{ 'NavTopBar.French' | translate }}</span>
            </button>
            <button mat-menu-item (click)="englishLanguage()">
                <img classe="resize" src="assets/images/united-kingdom.webp" />
                <span>{{ 'NavTopBar.English' | translate }}</span>
            </button>
        </mat-menu>

        <button mat-icon-button (click)="onThemeChange()">
            @if (!isDarkMode) {
                <mat-icon>dark_mode</mat-icon>
            }
            @if (isDarkMode) {
                <mat-icon>light_mode</mat-icon>
            }
        </button>

        @if (currentUser && showTopbarConnectedUser()) {
            <button mat-icon-button (click)="logout()" matTooltip="{{ 'NavTopBar.LogoutTooltip' | translate }}">
                <mat-icon>power_settings_new</mat-icon>
            </button>
        }
    </div>
</mat-toolbar>
